import { post, put, get, del } from "../request";
import { Axios } from "@/utils/axios";

/** 新增学员 */
export function addData(params) {
  return post(
    "/education-member-admin/memberWechatAdmin/addMemberWechat",
    params
  );
}

/** 修改学员 */
export function editData(params) {
  return put(
    "/education-member-admin/memberWechatAdmin/editMemberWechat",
    params
  );
}

/** 查询学员详情 */
export function getStudentInfo(id) {
  return get(`/education-member-admin/memberWechatAdmin/${id}`);
}

/** 分页查询学员列表 */
export function getStudents(params) {
  return get(
    "/education-member-admin/memberWechatAdmin/queryMemberWechatList",
    params
  );
}

/** 删除学员 */
export function deleteStudent(id) {
  return del(`/education-member-admin/memberWechatAdmin/delMemberWechat/${id}`);
}

/** 重置学员密码 */
export function resetPassword(id) {
  return post(
    `/education-member-admin/memberWechatAdmin/resetMemberPassword/${id}`
  );
}

/** 导出学员 */
export function exportStudent() {
  return Axios.get("/education-member-admin/memberWechatAdmin/export", {
    responseType: "blob"
  });
}

/** 导入学员 */
export function importStudent(data) {
  return Axios.post(
    "/education-member-admin/memberWechatAdmin/importMemberWechat",
    data,
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" }
    }
  );
}

/** 批量修改学员学期 */
export function batchUpdateTerm(params) {
  return put(
    "/education-member-admin/memberWechatAdmin/batchUpdateTerm",
    params
  );
}



// WEBPACK FOOTER //
// ./src/api/student/index.js